import { render, staticRenderFns } from "./RelativeTeam.vue?vue&type=template&id=41ecf175&scoped=true"
import script from "./RelativeTeam.vue?vue&type=script&lang=js"
export * from "./RelativeTeam.vue?vue&type=script&lang=js"
import style0 from "./RelativeTeam.vue?vue&type=style&index=0&id=41ecf175&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ecf175",
  null
  
)

export default component.exports